import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import { M04_TOPICS, M04_MODULE_INFO, getAllM04Problems } from '../data/mathExercises/M04_AnglesParallelLinesTrianglesQuadrilaterals';

const M04AnglesParallelLinesTrianglesQuadrilateralsExercise = ({ onProgress }) => {
  const topics = M04_TOPICS;
  const problems = getAllM04Problems();
  const moduleInfo = M04_MODULE_INFO;

  return (
    <ExerciseInterface
      moduleInfo={moduleInfo}
      topics={topics}
      problems={problems}
      onProgress={onProgress}
      className="m04-exercise"
    />
  );
};

export default M04AnglesParallelLinesTrianglesQuadrilateralsExercise; 